<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-md-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>DataBus</a>
      </li>
      <li class="breadcrumb-item">
        <a>Licenses</a>
      </li>
    </ol>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <h3>Licenses</h3>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>License ID</th>
                    <th>License Name</th>
                    <th>URI Count</th>
                    <th>Plugins</th>
                    <th>Order Status</th>
                    <th>Paid Date</th>
                    <th>Valid To</th>                    
                    <th>Action</th>
                </tr>
            </thead>
            <tbody *ngIf ="databusTableService.data && databusTableService.data.length > 0">
                <tr class="gradeX" *ngFor=" let order of databusTableService.remoteData | async; let i = index;">
                    <td>{{ order.licenseId }}</td>
                    <td>{{ order.licenseName }}</td>
                    <td>{{ order.uriCount }}</td>
                    <td>
                      <ul>
                        <!--<li *ngFor="let plugin in order.licensesPlugins">
                          {{ plugin}}
                        </li>-->
                      </ul>                        
                    </td>
                    <td>{{ order.licenseStatus }}</td>
                    <td>{{ order.paidDate | date }}</td>                    
                    <td>{{ order.validTo | date }}</td>
                    <td>
                      <div [ngSwitch]="order.licenseStatus">
                        <button *ngSwitchCase="'SAVED'" class="btn btn-xs btn-primary" (click)="openLicense(order)">Continue Editing</button>
                        <button *ngSwitchCase="'PENDING'" class="btn btn-xs btn-primary no-click" disabled="true">Processing</button>
                        <button *ngSwitchCase="'RENEW'" class="btn btn-xs btn-primary no-click" disabled="true">Processing</button>
                        <button *ngSwitchCase="'PROCESSING'" class="btn btn-xs btn-primary no-click" disabled="true">Processing</button>
                        <button *ngSwitchCase="'APPROVED'" class="btn btn-xs btn-primary" (click)="openForm(order);licenseForm.show()">Activate</button>
                        <button *ngSwitchCase="'ACTIVATED'" class="btn btn-xs btn-primary" (click)="openLicenseForm(order)">Download</button>
                        <button *ngSwitchCase="'ACTIVATED'" class="btn btn-xs btn-theme" (click)="renewLicense(order)">Renew</button>
                        <button *ngSwitchCase="'APPROVED'" class="btn btn-xs btn-theme" (click)="renewLicense(order)">Renew</button>
                        <button *ngSwitchCase="'EXPIRED'" class="btn btn-xs btn-theme" (click)="renewLicense(order)">Renew</button>
                      </div>
                    </td>

                    <!--<td>
                      <button *ngIf="order.licenseStatus == 'SAVED' || order.licenseStatus == 'ACTIVATED' || order.licenseStatus == 'APPROVED'" class="btn btn-xs btn-primary" (click)="openLicense(order)">Edit</button>
                      <button *ngIf="order.licenseStatus == 'ACTIVATED' && azureAuthService.isAdmin()" class="btn btn-outline btn-xs btn-danger" (click)="clearLicense(order)">Clear</button>
                      <button *ngIf="order.licenseStatus != 'ACTIVATED'" class="btn btn-outline btn-xs btn-danger" (click)="archiveLicense(order)">Archive</button>
                      <button class="btn btn-primary" (click)="revokeOrder(order)">Revoke</button>
                    </td>-->
                </tr>
            </tbody>
            <tbody *ngIf ="databusTableService.data == null || databusTableService.data.length == 0">
                <tr  class="gradeX">
                    
                    <!-- todo - Appears as if the order return from the new services doesn't include the commented out keys from below -->
                    <td colspan="10">No Approved Orders</td>  
                </tr>
            </tbody>
        </table>  
    </div>
  </div>
</div>

<div class="modal fade" bsModal #licenseForm="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg" >
    <div class="modal-content">
      <div class="modal-header">
        <b>Activate License</b>
        <button type="button" class="close pull-right btn btn-outline-default" aria-label="Close" (click)="licenseForm.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="licenseFormModel">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Server Token</label>
              <div class="input-group m-b">
                  <input id="serverToken" type="text" class="form-control" [(ngModel)]="licenseFormModel.serverToken" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>License File</label>
              <div class="input-group m-b">
                  <input *ngIf="newLicense" igxInput id="licenseFile" type="text" class="form-control"  [(ngModel)]="newLicense.licenseString" readonly/>
                  <input *ngIf="newLicense == null" igxInput id="licenseFile" type="text" class="form-control"  readonly/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="licenseForm.hide()" class="btn btn-white">Cancel</button>
        <button (click)="submitServerToken();licenseForm.hide()" class="btn btn-white">Save</button>
      </div>
    </div>
  </div>
</div>